<nav class="cp-navigation" aria-label="Page Selection Menu">
	<div *cpIfViewSize="'desktop'" class="cp-greeting">
		@let realtorInfo = realtorInfo$ | async;
		@if (isPreviewRealtor() && realtorInfo) {
			<h2 data-testid="greeting-welcome">Welcome, {{ realtorInfo.firstName }}</h2>
		} @else {
			<h2 data-testid="greeting-welcome">Welcome, {{ (userInfo$ | async)?.firstName }}</h2>
		}
		<div class="cp-home-details">
			@if (primaryOwnerName$ | async; as name) {
				<span class="cp-primary-owner">
					<mat-icon
						fontSet="material-symbols-outlined"
						class="cp-primary-owner-icon"
						[svgIcon]="'nav_house_chimney'">
					</mat-icon>
					{{name}}
				</span>
			}
			@if ((homeDetails$ | async)?.lot) {
				<span data-testid="greeting-address">
					{{(homeDetails$ | async)?.lot?.streetAddress1?.trim()}},{{(homeDetails$ | async)?.lot?.streetAddress2?.trim() ? ' ' + (homeDetails$ | async)?.lot?.streetAddress2?.trim() + ',' : ''}}
					<br />
					{{(homeDetails$ | async)?.lot?.city?.trim()}}, {{(homeDetails$ | async)?.lot?.stateProvince?.trim()}} {{(homeDetails$ | async)?.lot?.postalCode?.trim()}}
				</span>
			}
		</div>
	</div>
	<mat-list class="cp-navigation-list">
		<!-- Desktop and Non Collapsed View -->
		@if (navigationItems.length <= 5) {
			<ng-container *ngTemplateOutlet="navigation"></ng-container>
		} @else {
			<!-- Expanded View if > 5 menu options -->
			<!-- Mobile Views -->
			<ng-container *cpIfViewSize="'mobile'">
				<!-- First Four Navigation Items -->
				@for (item of navigationItems | slice:0:4; track item) {
				<mat-list-item class="cp-navigation-item" routerLinkActive="cp-navigation-item-selected" [routerLinkActiveOptions]="{ exact: item.exactMatch ?? false }" tabindex="-1">
					<div class="cp-navigation-item-content">
						<a
							class="cp-navigation-link"
							(click)="trackNavigation(item.label); setClientManagementModal(item.label)"
							(keydown.space)="$event.preventDefault(); trackNavigation(item.label); setClientManagementModal(item.label); changeRoute(item.routerLink)"
							[attr.data-id]="item.label + ' Nav Link Clicked'"
							[attr.data-testid]="item.routerLink + '-link'"
							[routerLink]="item.routerLink">
							<mat-icon
								fontSet="material-symbols-outlined"
								class="cp-navigation-icon"
								[svgIcon]="item.svg"
								[class.cp-font-fill]="isRouteActive(item.routerLink, item.exactMatch ?? false)">
									{{item.icon}}
								</mat-icon>
								{{item.label}}
							</a>
							@if (item.label === 'Message Center' && (unreadMessageCount$ | async); as unreadMessageCount) {
								<div class="cp-navigation-mc-unread-badge-container">
									<div class="cp-navigation-mc-unread-badge">{{unreadMessageCount}}</div>
								</div>
							}
						</div>
					</mat-list-item>
				}
				<!-- More Tile -->
				<mat-list-item class="cp-navigation-item" [matMenuTriggerFor]="overflowMenu" [class.cp-navigation-item-selected]="isRouteActive('MORE')">
					<div class="cp-navigation-item-content">
						<mat-icon fontSet="material-symbols-outlined" class="cp-navigation-icon material-symbols-outlined">more_horiz</mat-icon>
						<button class="cp-navigation-link">More</button>
					</div>
				</mat-list-item>
				<mat-menu #overflowMenu="matMenu" xPosition="after" yPosition="below" overlapTrigger class="cp-overflow-menu" backdropClass="cp-overflow-menu" panelClass="cp-overflow-menu">
					<ng-container *ngTemplateOutlet="navigation"></ng-container>
					<mat-list-item class="cp-close-item">
						<div class="cp-close-content" [attr.data-ai-dnt]="'dnt'">
							<mat-icon class="material-symbols-outlined">close</mat-icon>
							<button class="cp-close-button">Close</button>
						</div>
					</mat-list-item>
				</mat-menu>
			</ng-container>
			<!-- Desktop and Tablet Views -->
			<ng-container *cpIfViewSize="['desktop', 'tablet']">
				<ng-container *ngTemplateOutlet="navigation"></ng-container>
			</ng-container>
		}
	</mat-list>
</nav>

<!-- Navigation Items Template -->
<ng-template #navigation>
	@for (item of navigationItems; track item; let i = $index) {
		<mat-nav-list
			role="navigation"
			class="cp-navigation-item"
			routerLinkActive="cp-navigation-item-selected"
			[routerLinkActiveOptions]="{ exact: item.exactMatch ?? false }"
			tabindex="-1"
			[attr.aria-label]="'navigation-item-' + i">
			<div class="cp-navigation-item-content">
				<a
					class="cp-navigation-link"
					(click)="trackNavigation(item.label); setClientManagementModal(item.label)"
					(keydown.space)="$event.preventDefault(); trackNavigation(item.label); setClientManagementModal(item.label); changeRoute(item.routerLink)"
					[attr.data-id]="item.label + ' Nav Link Clicked'"
					[attr.data-testid]="item.routerLink + '-link'"
					[routerLink]="item.routerLink">
					<mat-icon
						fontSet="material-symbols-outlined"
						class="cp-navigation-icon"
						[svgIcon]="item.svg"
						[class.cp-font-fill]="isRouteActive(item.routerLink, item.exactMatch ?? false)">
						{{item.icon}}
					</mat-icon>
					{{item.label}}
				</a>
				@if (item.label === 'Message Center' && (unreadMessageCount$ | async); as unreadMessageCount) {
					<div class="cp-navigation-mc-unread-badge-container">
						<div class="cp-navigation-mc-unread-badge">{{unreadMessageCount}}</div>
					</div>
				}
			</div>
		</mat-nav-list>
	}
</ng-template>